import {
  deprecated,
  func,
  object,
  optional,
  string,
  boolean,
  record,
  Struct,
} from 'superstruct';

export interface User {
  id: string;
  employer_group_id: string;
  tenant_id: string;
}

export interface SendAnalyticsPageViewParams {
  screen_name?: string;
  path?: string;
  [key: string]: string | unknown;
}

export const analyticsClientConfigSchema = object({
  GAPropertyId: deprecated(optional(string()), () =>
    console.warn(
      'This property is no longer supported, you can safely remove it',
    ),
  ),
  segmentKey: deprecated(optional(string()), () =>
    console.warn(
      'This property is no longer supported on the client side. Please use server-driven configurations',
    ),
  ),
  onIdentify: optional(func() as unknown as Struct<(user: User) => void, null>),
  onTrackEvent: optional(
    func() as unknown as Struct<
      (eventName: string, props: Record<string, any>) => void,
      null
    >,
  ),
  onTrackPageViewEvent: deprecated(
    optional(
      func() as unknown as Struct<
        (screen_name: string, props: unknown) => void,
        null
      >,
    ),
    () =>
      // eslint-disable-next-line no-console
      console.warn(
        'onTrackPageViewEvent is deprecated. Please use onTrackEvent instead.',
      ),
  ),
  shouldEnableLocalAnalyticsLogging: optional(boolean()),
  customProperties: optional(record(string(), string())),
});
